export interface UseFollowCompany {
  followCompany(selectedCompany: { id: number | string; name: string }): Promise<void>
}

export function useFollowCompany() {
  const { $analytics } = useNuxtApp()
  const { state: userState, setFollowCompany } = useUser()

  async function followCompany(selectedCompany: { id: number | string; name: string }) {
    const isFollowing = userState.value.followingCompanies.some(({ id }) => id === selectedCompany.id)

    await setFollowCompany({
      action: isFollowing ? 'unfollow' : 'follow',
      id: selectedCompany.id,
    })

    $analytics.track(isFollowing ? 'companiesCompanyUnfollowed' : 'companiesCompanyFollowed', {
      companyName: selectedCompany.name,
      companyId: selectedCompany.id,
    })
  }

  return { followCompany }
}
